import { render } from "./NewestNews.vue?vue&type=template&id=1bdd537e&scoped=true"
const script = {}

import "./NewestNews.vue?vue&type=style&index=0&id=1bdd537e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bdd537e"]])

export default __exports__